import { render, staticRenderFns } from "./admins-list.component.html?vue&type=template&id=33528504&scoped=true&external"
import script from "./admins-list.component.ts?vue&type=script&lang=ts&external"
export * from "./admins-list.component.ts?vue&type=script&lang=ts&external"
import style0 from "./admins-list.component.scss?vue&type=style&index=0&id=33528504&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33528504",
  null
  
)

export default component.exports